import { CareInfoDetails, CarehomeAddressType } from '@typings/CarehomeInfo';
import { ApiResponse } from '@typings/ApiResponse';
import { axiosIns } from './index';

const teamsUrl = '/carehome/teams';

const addCarehomeAddress = async (id: string, address: CarehomeAddressType) => {
  const { addressLine1, addressLine2, city, county, postCode } = address;
  const response = await axiosIns.post(`${teamsUrl}/info`, {
    carehome_partner_id: id,
    address_line1: addressLine1,
    address_line2: addressLine2,
    city,
    county,
    post_code: postCode,
  });
  return response.data;
};

const getCarehomeInfo = async (
  id: string
): Promise<ApiResponse<CareInfoDetails>> => {
  const response = await axiosIns.get(`${teamsUrl}/info/${id}`);
  return response.data;
};

const editCarehomeAddress = async (
  id: string,
  address: CarehomeAddressType
): Promise<ApiResponse<CareInfoDetails>> => {
  const { addressLine1, addressLine2, city, county, postCode } = address;

  const response = await axiosIns.put(`${teamsUrl}/info/${id}`, {
    carehome_partner_id: id,
    address_line1: addressLine1,
    address_line2: addressLine2,
    city,
    county,
    post_code: postCode,
  });
  return response.data;
};

const addCarehomePhoneNumber = async (id: string, phone: string) => {
  const response = await axiosIns.post(`${teamsUrl}/info-phone-number`, {
    phone_number: phone,
    carehome_id: id,
  });
  return response.data;
};

const addSpeciality = async (id: string, speciality: string) => {
  const response = await axiosIns.post(`${teamsUrl}/info-speciality`, {
    speciality,
    carehome_id: id,
  });
  return response.data;
};

export {
  addCarehomeAddress,
  getCarehomeInfo,
  editCarehomeAddress,
  addCarehomePhoneNumber,
  addSpeciality,
};
